export default __webpack_public_path__ + "static/media/bl-unity.6752841d.jpg";